import {AppComponent} from './app/app.component';
import {bootstrapApplication} from '@angular/platform-browser';
import {loadTranslations} from '@angular/localize';
import {appConfig} from './app/app.config';
import {environment} from './environments/environment';
import {DcBaseInitializationService, SupportedLocales,} from '@datachain/ui-sdk/common';
import {loadMessages, locale} from 'devextreme/localization';
import dayjs from "./app/core/configs/dayjs";

async function start(): Promise<void> {
	await fetchTranslations();
}

async function fetchTranslations(): Promise<void> {
	const saved = localStorage.getItem('pref:lang');
	const usedLangLocale =
		saved === null || saved === undefined
			? SupportedLocales.Fr
			: getLanguage(saved);

	DcBaseInitializationService.updateConfig(
		DcBaseInitializationService.getConfigInstance().setLangLocal(
			usedLangLocale,
		),
	);

	let adbUiMessages: Record<string, string> = {};

	if (usedLangLocale === SupportedLocales.Fr) {
		const adbUiFrMessages = await import(
			'@datachain/ui-sdk/assets/locale/messages.fr-FR.json'
			);
		adbUiMessages = adbUiFrMessages.translations;
		const frMessages = await import('devextreme/localization/messages/fr.json');
		loadMessages(frMessages);
		locale(usedLangLocale);
		const frPreset = await import('dayjs/esm/locale/fr.js');
		dayjs.locale(frPreset);
		dayjs.locale('fr');
	} else {
		const adbUiEnMessages = await import(
			'@datachain/ui-sdk/assets/locale/messages.en-US.json'
			);
		adbUiMessages = adbUiEnMessages.translations;
		locale(usedLangLocale);
		const enPreset = await import('dayjs/esm/locale/en.js');
		dayjs.locale(enPreset);
		dayjs.locale('en');
	}

	fetch(`${environment.localePath}/messages.${usedLangLocale}.json`)
		.then((response) => {
			return response.json();
		})
		.then((translationJson) => {
			const translation = translationJson['translations'];
			const _tra = { ...translation, ...adbUiMessages };
			if (translation) {
				loadTranslations(_tra);
			}
		})
		.catch((err) => {
			console.error(err);
		});
}

function getLanguage(saved: string): string {
	switch (saved) {
		case 'en':
			return SupportedLocales.En;
		case 'fr':
			return SupportedLocales.Fr;
		case 'browser': {
			const lang: string =
				navigator.language || (navigator as any).userLanguage;

			if (lang === 'fr-FR' || lang === 'fr') {
				return SupportedLocales.Fr;
			}
			if (lang === 'en-US' || lang === 'en') {
				return SupportedLocales.En;
			}
			break;
		}
	}
	return SupportedLocales.Fr;
}

function runApp(): void {
	bootstrapApplication(AppComponent, appConfig).catch((err) =>
		console.error(err),
	);
}

start().then(runApp, (err) => console.error(err));
